import { RowAction } from "@beeldit/core/enums/RowAction.enum";
import { TableAction } from "@beeldit/core/enums/TableAction.enum";
import { HandCoins, Pencil, Plus, Trash } from "@phosphor-icons/react";
import { t } from "i18next";

const config = {
  modelName: "payment",
  modelPluralName: "payments",
  endpoint: "payments",
  indexQueryParams: {
    relations: ["payable", "payable.customer"],
  },
  tableConfig: {
    index: null,
    actions: [
    ],
    rowActions: [
      {
        name: 'pay',
        label: "pay",
        icon: <HandCoins size={20} />,
        allowed: true,
        show: (element: any) => {
          return !element.payment || !element.payment.payed;
        },
        action: (element: any) => {
          console.log("pay", element);
        },
        data: "external_id"
      },
    ],
    rowConfiguration: {
      class: (element: any) => {
        return null;
      },
    },
    columns: [
      {
        name: "id",
        label: "#",
        key: "id",
        type: "number",
        show: true,
        allowOrder: true,
      },
      {
        name: "customer",
        label: "customer",
        key: "payable.customer.full_name",
        type: "text",        
        show: true,
        allowOrder: true,
      },
      {
        name: "created_at",
        label: "created_at",
        key: "created_at",
        type: "date",        
        show: true,
        allowOrder: true,
      },
      {
        name: "amount",
        label: "amount",
        key: "amount",
        type: "currency",
        currency: "EUR",
        show: true,
        allowOrder: true,
      },
      {
        name: "payed",
        label: "payed",
        key: "payed",
        type: "boolean",
        show: true,
        allowOrder: true,
      },
    ],
    pagination: {
      enabled: true,
      back: true,
    },
  },
  filterConfig: {
    type: "object",
    properties: {
      search: {
        type: "string",
      },
    },
  },
  filterUIConfig: {
    uiScheme: {
      className: "filters-container",
      search: {
        "ui:options": {
          label: false, // Oculta el título del campo
          placeholder: "Buscar...",
        },
      },
    },
    widgets: {},
  },
  formSchema: {
    type: "object",
    properties: {
      // // Name
      // name: {
      //   type: "string",
      //   title: t("name"),
      // },
      // // Price
      // price: {
      //   type: "number",
      //   title: t("price"),
      //   minimum: 0,
      //   dafault: 0,
      // },
    },
  },
};
export default config;
